import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Collapse,
  Card,
  CardContent,
  Tooltip,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { Close as CloseIcon, ExpandLess, ExpandMore } from "@material-ui/icons";
import { MessageService } from "../../../services/MessageService";
import RenderMessage from "./RenderMessage";

const MessagesModal = ({ open, handleClose, accountId, userId, messages }) => {
  const [expanded, setExpanded] = useState({});
  const [dismissedMessages, setDismissedMessages] = useState([]);

useEffect(() => {
  if (!window?.acsb) { // or whatever global indicates ADA is active
    if (open) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden"; // lock normal scroll
      return () => {
        document.body.style.overflow = originalOverflow; // restore
      };
    }
  }
}, [open]);

  const handleExpandClick = (id) => {
    setExpanded((prevState) => ({
      ...prevState,
      // toggle: undefined/open → false, false → undefined/open
      [id]: prevState[id] === false ? true : false,
      // [id]: !prevState[id],
    }));
  };

  const handleDismissMessage = (messageId, checked) => {
    setDismissedMessages((prev) => {
      if (checked) {
        // add id if not present
        if (prev.includes(messageId)) return prev;
        return [...prev, messageId];
      } else {
        // remove id if present
        return prev.filter((id) => id !== messageId);
      }
    });
  };

  const onModalClose = () => {
    if (dismissedMessages.length > 0) {
      MessageService.dontShowMessageAgain(accountId, userId, dismissedMessages);
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="messages-dialog-title"
      maxWidth="md"
      fullWidth
      PaperProps={{ // added for ADA
        sx: {
          overflowY: "visible", // let DialogContent handle scroll
          display: "flex",
          flexDirection: "column",
          maxHeight: "80vh",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        className="announcement-title"
      >
        <DialogTitle
          id="alert-dialog-slide-title"
          className="dialog-title announcement-title"
        >
          Announcements
        </DialogTitle>
        <IconButton color="inherit" onClick={onModalClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent
        sx={{ // Added sx prop for ADA
          overflowY: "auto", // allow scroll if content is taller than maxHeight
          maxHeight: "70vh", // limit height for viewport
          padding: 0,
        }}
      >
        {messages.length > 0 ? (
          messages.map((message) => {
            const isExpanded = expanded[message.id] !== false;
            return (
              <Box key={message.id} sx={{ minWidth: 275 }} className="mt-3">
                <Card variant="outlined">
                  <CardContent className="no-padding">
                    <div className="mb-2 card-header d-flex justify-content-between align-items-center btn-styling stats-table-header">
                      <label className="sub-heading mb-0">
                        {message.title}
                      </label>
                      <Tooltip title={isExpanded ? "Collapse" : "Expand"}>
                        <IconButton
                          onClick={() => handleExpandClick(message.id)}
                          aria-expanded={isExpanded}
                          aria-label="show more"
                        >
                          {isExpanded ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                      </Tooltip>
                    </div>
                    <Collapse in={isExpanded}>
                      {message.content !== "" ? (
                        <RenderMessage content={message.content} />
                      ) : (
                        <p>{message.description || "No content available."}</p>
                      )}
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e) =>
                              handleDismissMessage(message.id, e.target.checked)
                            }
                            checked={dismissedMessages.includes(message.id)}
                            color="primary"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevents modal submit / close
                                handleDismissMessage(
                                  message.id,
                                  !dismissedMessages.includes(message.id)
                                );
                              }
                            }}
                          />
                        }
                        className="mb-0"
                        label={
                          <span style={{ fontSize: 16 }}>
                            Don't show this message again
                          </span>
                        }
                      />
                    </Collapse>
                  </CardContent>
                </Card>
              </Box>
            );
          })
        ) : (
          <p>Loading Messages....</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MessagesModal;
